import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import { StyledShadow } from './Background.styled';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && <BgPlaceholder $type={PlaceholderType.Default} />}
		<StyledShadow />
	</Fragment>
);

export { Background };
